/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setBrandCheckoutSecurity} from '../api'

export const useMutationSetBrandCheckoutSecurity = createReactQueryMutationHook('setBrandCheckoutSecurity', setBrandCheckoutSecurity)
